import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import Feather from 'react-native-vector-icons/Feather';

export const Container = styled.TouchableOpacity`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-style: solid;
  border-top-width: 1px;
  border-top-color: ${({theme}) => theme.colors.border};
  padding: ${RFValue(16)}px 24px;
`;

export const HelpArticleText = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
  width: 80%;
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const HelpArticleIcon = styled(Feather)`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(14)}px;
`;
